import React from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';

export default function WithErasa() {
  const { t } = useTranslation();

  return (
    <div className={styles.content}>
      <h2 style={{ display: 'none', width: '0', height: '0' }}>Protection for OnlyFans Content through Erasa</h2>
      <div className={styles.title}>
        <span>
          {t('Protection for OnlyFans Content through')} <span style={{ color: '#428DFF' }}>Erasa</span>
        </span>
      </div>
      <p className={styles.desc}>
        {t(
          'As an OnlyFans creator, leaked content can destroy your income and reputation overnight. Erasa’s AI-powered copyright protection acts as your 24/7 digital guardian, scanning the web, enforcing takedowns, and safeguarding your earnings',
        )}
      </p>
    </div>
  );
}
